
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import defaultDemoSource from '!!raw-loader!./demo/demo.twig';
import defaultDemo from './demo/demo.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Bio" mdxType="Meta" />
    <h1>{`Bio`}</h1>
    <p>{`The Bio layout object can be used for extended biographical details that include an avatar, an extended text description and optional meta information.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Default" parameters={{
        docs: {
          source: {
            code: defaultDemoSource
          }
        }
      }} mdxType="Story">
    {defaultDemo}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`avatar`}</inlineCode>{` (block): Block to add a bio avatar.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{` (block): Block to add the main bio content.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`meta`}</inlineCode>{` (block): Optional block to add meta information (e.g. bio links).`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const defaultStory = assertIsFn(defaultDemo);
defaultStory.storyName = 'Default';
defaultStory.parameters = { storySource: { source: 'defaultDemo' }, ...{
  docs: {
    source: {
      code: defaultDemoSource
    }
  }
} };

const componentMeta = { title: 'Objects/Bio', includeStories: ["defaultStory"],  };

const mdxStoryNameToKey = {"Default":"defaultStory"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;